import { useFormatDate } from "src/internationalization";

export const useGetScenarioNamePlaceholderExample = () => {
  const formatDate = useFormatDate();

  const getScenarioNamePlaceholderExample = () => {
    return formatDate(new Date(), {
      year: "numeric",
      month: "long",
    });
  };

  return getScenarioNamePlaceholderExample;
};
